import moment from "moment";
import "moment/locale/id";
import { CurrencyFormat } from "../../../../components/helpers";

export const convertDataSimulation = (data, loanAmount) => {
    let converted = [{
        key: 0,
        periode: '-',
        capitalLoan: '-',
        installmentAmount: '-',
        totalInstallment: '-',
        remainingInstallment: `Rp ${CurrencyFormat(loanAmount || 0)}`,
    }];

    if (!data) return [];

    data.forEach((item, index) => {
        converted.push({
            key: index + 1,
            periode: item.period_number || '-',
            capitalLoan: item.capital_loan > 0 ? `Rp ${CurrencyFormat(item.capital_loan || 0)}` : '-',
            installmentAmount: item.installment_amount > 0 ? `Rp ${CurrencyFormat(item.installment_amount || 0)}` : '-',
            totalInstallment: item.capital_loan + item.installment_amount > 0 ? `Rp ${CurrencyFormat(item.capital_loan + item.installment_amount || 0)}` : '-',
            remainingInstallment: `Rp ${CurrencyFormat(item.remaining_loan || 0)}`,
        });
    });
    return converted;
};
